<template lang="pug">
.m-card-header(
  v-if="source.ptype == 20"
  :id="source.id"
  ref="leagueHeader"
  role='button' 
  aria-expanded='false' 
  :aria-controls="'league-' + source.id"
  :class="leagueKindClassOf(source.leagueId)"
  @click="handleHeaderClick"
)
  .group
    .fav-icon(:class="fav == true ? 'active' : ''" @click.stop="xToggleFavs(source.matches, $event)")
      i.fa-solid.fa-star
    .icon.inactive
      ThemeImage(:src="'/images/light/sport/blue/' + source.sportsId + '.svg'" width='20' height='20') 
    .icon.active
      ThemeImage(:src="'/images/light/sport/white/' + source.sportsId + '.svg'" width='20' height='20')
    .tag(v-if="leagueKindClassOf(source.leagueId)") {{ $t("ui.virtual") }}
    .league-name 
      template(v-if="source.betTypeId != 'orz'")
        template(v-if="[40].includes(source.sportsId)") {{ $dayjs(source.lastMatchTime).format("MM/DD hh:mm A") }} {{ source.leagueName }}
        template(v-else) {{ source.leagueName }}
      template(v-else) [{{ $dayjs(source.lastMatchTime).format("MM/DD/YYYY") }}] {{ source.leagueName }}
  .result(v-if="[40].includes(source.sportsId)")
    a(
      :href="'/ngresult?q=' + source.leagueId + '&n=' + encodeURI(league()[source.leagueId][4].replace('+', '$')) + '&u=' + encodeURI(league()[source.leagueId][6])"
      target="_blank"
      onclick="window.open(this.href,'_blank','top=10,height=900,width=450,status=no,toolbar=no,menubar=no,location=no');return false;"
    )
      i.fas.fa-chart-bar
  .event-count(v-else) {{ source.matchList.length }}

//- .card-header.d-flex.align-items-center.bg-normal-head.collapse-head(
//-   v-if="source.ptype == 20"
//-   :id="source.id"
//-   :class="source.marketId == 3 ? 'live ' + source.categoryId : [41, 42, 43, 44, 47].includes(source.sportsId) ? 'live ' + source.categoryId : source.categoryId"
//-   data-toggle='collapse'
//-   :data-target="'#league-' + source.leagueId"
//- )
//-   .mr-2
//-     img(:src="'/images/icon-sport-svg/' + getSportsImage(source.sportsId)" width='20' height='20')
//-   .bg-star(@click="xToggleFavs(source.matches, $event)" :class="fav == true ? 'active' : ''")
//-   .league-title.flex-grow-1.text-uppercase(:class="['orz'].includes(menu3) ? 'league-title-orz' : menuY != 0 ? 'event' : ''")
//-     template(v-if="source.betTypeId != 'orz'")
//-       template(v-if="[40].includes(source.sportsId)") {{ $dayjs(source.lastMatchTime).format("MM/DD hh:mm A") }} {{ source.leagueName }}
//-       template(v-else) {{ source.leagueName }}
//-     template(v-else) [{{ $dayjs(source.lastMatchTime).format("MM/DD/YYYY") }}] {{ source.leagueName }}
//-   .tooltip(v-if="![40].includes(source.sportsId) && source.leagueInfo != null" @click="xToggleTooltips($event)")
//-     i.fal.fa-exclamation-circle
//-     .tooltiptext
//-       | {{ source.leagueInfo }}
//-   .btn-4d(v-if="special.includes(source.sportsId)")
//-     //- template(v-if="[41, 42, 43, 44, 45, 46, 47, 49, 51, 53].includes(source.sportsId)")
//-     //-   a(
//-     //-     :href="'/efresult?q=' + source.sportsId + '&n=' + encodeURI(league()[source.leagueId][4].replace('+', '$')) "
//-     //-     target="_blank"
//-     //-     onclick="window.open(this.href,'_blank','top=10,height=900,width=450,status=no,toolbar=no,menubar=no,location=no');return false;"
//-     //-   )
//-     //-     i.fas.fa-chart-bar
//-     template(v-if="[40].includes(source.sportsId)")
//-       a(
//-         :href="'/ngresult?q=' + source.leagueId + '&n=' + encodeURI(league()[source.leagueId][4].replace('+', '$')) + '&u=' + encodeURI(league()[source.leagueId][6])"
//-         target="_blank"
//-         onclick="window.open(this.href,'_blank','top=10,height=900,width=450,status=no,toolbar=no,menubar=no,location=no');return false;"
//-       )
//-         i.fas.fa-chart-bar
//-     template(v-else)
//-       a(
//-         :href="'/efresult?q=' + source.sportsId + '&n=' + encodeURI(league()[source.leagueId][4].replace('+', '$')) "
//-         target="_blank"
//-         onclick="window.open(this.href,'_blank','top=10,height=900,width=450,status=no,toolbar=no,menubar=no,location=no');return false;"
//-       )
//-         i.fas.fa-chart-bar
//-   .league-number(v-else) {{ source.matchList.length }}
</template>

<script>
import config from "@/config";
import mixinTypes from "@/library/mixinTypes";
import { EventBus } from "@/library/_event-bus.js";

export default {
  mixins: [mixinTypes],
  props: {
    source: {
      type: Object
    }
  },
  data() {
    return {
      collapseShowHandler: null,
      collapseHideHandler: null,
      leagueCollapseEl: null
    }
  },
  computed: {
    special() {
      return config.special;
    },
    // Derived rather than set in mounted(): league rows are reused across refreshes now, so a mount-time
    // flag would stop following changes to the favorite list or to the league's own match list
    fav() {
      if (this.menu0 == "favorite") {
        return true;
      }
      if (!this.favorite) {
        return false;
      }
      var items = this.source.matches;
      for (var n in items) {
        if (this.favorite.indexOf(items[n][2]) == -1) {
          return false;
        }
      }
      return true;
    }
  },
  mounted() {
    $(".result").click(function(event){
      event.stopPropagation();
    });

    // Initialize collapse state sync
    this.$nextTick(() => {
      this.initCollapseStateSync();
    });
  },
  beforeDestroy() {
    // Clean up event listeners
    if (this.leagueCollapseEl) {
      if (this.collapseShowHandler) {
        this.leagueCollapseEl.removeEventListener('show.bs.collapse', this.collapseShowHandler);
      }
      if (this.collapseHideHandler) {
        this.leagueCollapseEl.removeEventListener('hide.bs.collapse', this.collapseHideHandler);
      }
    }
  },
  methods: {
    league() {
      return this.$store.getters.data.league;
    },
    getSportsImage(e) {
      return config.getSportsImage(e);
    },
    leagueKindClassOf(leagueId) {
      return this.$store.getters.leagueKindClassOf(leagueId);
    },
    xToggleTooltips(e) {
      // console.log("xToggleTooltips", e);
      e.stopPropagation();
    },
    initCollapseStateSync() {
      const headerEl = this.$refs.leagueHeader;
      if (!headerEl) return;

      // Keyed on the group id, not the league id: the same league can appear in more than one section
      // (live and today, or two groups under time sorting) and each header must own its own panel
      const targetId = '#league-' + this.source.id;
      const collapseEl = document.querySelector(targetId);
      if (!collapseEl) return;

      // Store reference for event handlers
      this.leagueCollapseEl = collapseEl;

      // Sync initial state
      const isCollapsed = !collapseEl.classList.contains('show');
      if (isCollapsed) {
        headerEl.classList.add('collapsed');
        headerEl.setAttribute('aria-expanded', 'false');
      } else {
        headerEl.classList.remove('collapsed');
        headerEl.setAttribute('aria-expanded', 'true');
      }

      // Create event handlers that only respond to events from the league collapse element
      this.collapseShowHandler = (event) => {
        // Only handle events from the league collapse, not nested collapses (like matchDetail)
        if (event.target === this.leagueCollapseEl) {
          headerEl.classList.remove('collapsed');
          headerEl.setAttribute('aria-expanded', 'true');
        }
      };

      this.collapseHideHandler = (event) => {
        // Only handle events from the league collapse, not nested collapses (like matchDetail)
        if (event.target === this.leagueCollapseEl) {
          headerEl.classList.add('collapsed');
          headerEl.setAttribute('aria-expanded', 'false');
        }
      };

      // Listen to collapse events to sync state
      collapseEl.addEventListener('show.bs.collapse', this.collapseShowHandler);
      collapseEl.addEventListener('hide.bs.collapse', this.collapseHideHandler);
    },
    handleHeaderClick(e) {
      if (e.target.closest('.fav-icon')) {
        return;
      }
      const targetId = '#league-' + this.source.id;
      const collapseEl = document.querySelector(targetId);
      if (collapseEl) {
        const collapse = bootstrap.Collapse.getInstance(collapseEl) || new bootstrap.Collapse(collapseEl, { toggle: false });
        if (collapseEl.classList.contains('show')) {
          collapse.hide();
        } else {
          collapse.show();
        }
      }
    },
    xToggleFavs(items, e) {
      e.stopPropagation();
      e.preventDefault();
      var favList = [];
      for (var n in items) {
        favList.push(items[n][2]);
      }
      if (this.fav == false) {
        this.$store.dispatch("layout/setFavorite", favList);
      } else {
        this.$store.dispatch("layout/delFavorite", favList);
      }

      if (this.menu0 == "favorite") {
        EventBus.$emit("GET_MARKET");
      }
    }
  },
}
</script>